// extracted by mini-css-extract-plugin
export default {"default":"style_default__GDEq2","index":"style_index__gfw1k","project":"style_project__DMltC","item":"style_item__GddeE"};